<template>


	<div class="relative f fy">



		<el-table class="" :data="records" border stripe>

			<el-table-column prop="id" label="角色ID">
			</el-table-column>
			<el-table-column prop="name" label="角色名称">
			</el-table-column>






			<el-table-column label="operate">
				<template slot="header">

					<div class="relative cm-0-5">
						<el-button type="primary" size="mini" @click="load()">refresh</el-button>
						<el-button type="primary" size="mini" @click="create()">
							create
						</el-button>
					</div>
				</template>
				<template slot-scope="scope">
					
					<el-button v-if="mode=='select'" type="primary" size="mini" @click="$emit('select',scope.row)">
						select
					</el-button>
					<div v-else class="relative cm-0-5">

						<el-button type="primary" size="mini" @click="update(scope.row)">
							update
						</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination class="relative text-center mt-2" background layout="prev, pager, next, total" :total="total"
			:page-size="size" :current-page="page" @current-change="load">
		</el-pagination>
	</div>

</template>

<script>
	import OptionTag from '@/components/OptionTag'
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		components: {
			OptionTag,
		},
		data() {
			return {
				places: [
					'HOME_SWIPER',
					'HOME_MENU',
				],
				form: {},
				records: [],
				total: 0,
				pages: 0,
				size: 10,
				page: 1,
				params: {},

			}
		},
		mounted() {
			this.search();
		},
		methods: {
			search() {
				this.params = {
					...this.form,
					...this.propParams
				}
				this.load(1);
			},
			load(page) {
				page = page || this.page || 1;
				console.log(this.options)
				request({
					loading: true,
					url: '/api/role/selectRolePage',
					data: {
						...this.params,
						page,
					},
					success: resp => {
						this.records = resp.data.records;
						this.total = resp.data.total;
						this.pages = resp.data.pages;
						this.page = page;
					}
				})

			},

			create() {
				dialogs.open('RoleForm', {
					mode: 'create',
					title: '新建角色',
					success: this.load
				})
			},

			update(row) {
				dialogs.open('RoleForm', {
					mode: 'update',
					title: '编辑角色',
					propForm: {
						...row
					},
					success: this.load
				})
			},


		}
	}
</script>

<style>




</style>